import { apiClient } from './config.js';
import type {
  ProcessingStatusResponse,
  ProcessingStatusWithMetadata,
  SuccessResponse,
} from './types.js';

/**
 * Get processing status for an announcement
 */
export async function getProcessingStatus(
  announcementId: string
): Promise<ProcessingStatusResponse> {
  const response = await apiClient.get<ProcessingStatusResponse>(
    `/processing/${announcementId}`
  );
  return response.data;
}

/**
 * Get detailed processing status with announcement metadata
 * Useful for real-time UI updates
 */
export async function getDetailedProcessingStatus(
  announcementId: string
): Promise<ProcessingStatusWithMetadata> {
  const response = await apiClient.get<ProcessingStatusWithMetadata>(
    `/processing/${announcementId}/detailed`
  );
  return response.data;
}

/**
 * Trigger processing for an announcement
 */
export async function triggerProcessing(
  announcementId: string,
  forceReprocess: boolean = false,
  forceExtractImages: boolean = false
): Promise<SuccessResponse> {
  const params: Record<string, boolean> = { force_reprocess: forceReprocess };
  if (forceExtractImages) {
    params.force_extract_images = true;
  }
  const response = await apiClient.post<SuccessResponse>(
    `/processing/${announcementId}`,
    null,
    { params }
  );
  return response.data;
}
